import _ from 'lodash';
const HOVER_CLASS = 'column-move__hover';
const LEFT_CLASS = 'LEFT';
const RIGHT_CLASS = 'RIGHT';
const DRAGGING_CLASS = 'in-dragging';
let columnMoveConfig = {
    fromTargetKey: null,
    hoverTarget: null,
    toTarget: null,
    toTargetKey: null,
    type: null,
};
function removeHoverClass(el) {
    try {
        el.classList.remove(HOVER_CLASS);
        el.classList.remove(LEFT_CLASS);
        el.classList.remove(RIGHT_CLASS);
    }
    catch (error) {
        console.log(error);
    }
}
export function useVxeColumnMove({ params, cb, }) {
    const tableEl = _.get(params, '$table.$el');
    function ondrag() { }
    function ondragend() {
        tableEl.classList.remove(DRAGGING_CLASS);
        if (columnMoveConfig.hoverTarget) {
            removeHoverClass(columnMoveConfig.hoverTarget);
        }
        const { fromTargetKey, toTargetKey, type, } = columnMoveConfig;
        if (toTargetKey && fromTargetKey !== toTargetKey) {
            console.log('拖拽结束:', `
                将 ${fromTargetKey} 移动到 ${toTargetKey} 的 ${type}
            `);
            cb(columnMoveConfig);
        }
        else {
            console.log('无效拖拽');
        }
        columnMoveConfig = {
            fromTargetKey: null,
            hoverTarget: null,
            toTarget: null,
            toTargetKey: null,
            type: null,
        };
    }
    function ondragenter() { }
    function ondragleave(event) {
        removeHoverClass(event.target);
        columnMoveConfig.toTargetKey = null;
    }
    function ondragover(event) {
        if (columnMoveConfig.hoverTarget) {
            columnMoveConfig.hoverTarget.classList.remove(HOVER_CLASS);
        }
        const hoverTarget = event.target;
        columnMoveConfig.hoverTarget = hoverTarget;
        if (hoverTarget.dataset.colKey === columnMoveConfig.fromTargetKey)
            return;
        const targetPosition = hoverTarget.getBoundingClientRect();
        const type = (event.clientX - targetPosition.left) < targetPosition.width * 0.5 ? LEFT_CLASS : RIGHT_CLASS;
        columnMoveConfig.type = type;
        hoverTarget.classList.remove(type === LEFT_CLASS ? RIGHT_CLASS : LEFT_CLASS);
        hoverTarget.classList.add(type);
        hoverTarget.classList.add(HOVER_CLASS);
        event.preventDefault();
    }
    function ondragstart(event) {
        event.dataTransfer.effectAllowed = 'move';
        try {
            event.dataTransfer.setData('text/plain', '');
        }
        catch (e) {
            //
        }
        columnMoveConfig.fromTargetKey = event.target.dataset.colKey;
        tableEl.classList.add(DRAGGING_CLASS);
        console.log('拖拽开始', event.target, columnMoveConfig);
    }
    function ondrop(event) {
        columnMoveConfig.toTargetKey = event.target.dataset.colKey;
        event.preventDefault();
    }
    return {
        draggable: true,
        ondrag,
        ondragend,
        ondragenter,
        ondragleave,
        ondragover,
        ondragstart,
        ondrop,
    };
}
